export default "__VITE_ASSET__C5EvqRBR__"